// @flow
import * as React from 'react'
import {translate} from 'react-i18next'
import {
  Banner,
  Grid,
  Link,
  NestedSection,
  Section,
  SectionImage,
  SectionTitle,
  SplitSection,
  Testimonial,
  Traits,
  Trait
} from 'tutellus-ui'

import {Page} from './Page'

export const Teachers = translate('teachers')(({t}) =>
  <Page>
    <Banner title={t('title')} background_url={t('background_url')}>
      <p>{ t('description') }</p>
      <Link button primary
        href={t('urls:register')}
      >
        { t('become_teacher') }
      </Link>
    </Banner>
    <Section title={t('reasons_title')}>
      <Traits>{
        JSON.parse(t('reasons')).map(reason =>
          <Trait key={reason}
            title={t(`${reason}_title`)}
            icon={t(`${reason}_icon`)}>
            { t(`${reason}_description`) }
          </Trait>
        )
      }</Traits>
    </Section>
    <SplitSection title={t('metrics_title')}
      image={t('metrics_image')}
      light>
      <p>{ t('metrics_description') }</p>
    </SplitSection>
    <SplitSection reverse
      title={t('profits_title')}
      image={t('profits_image')}>
      <p>{ t('profits_description') }</p>
    </SplitSection>
    <NestedSection dark>
      <Section>
        <SectionImage src={t('promotions_image')} />
        <SectionTitle>{ t('promotions_title') }</SectionTitle>
        { t('promotions_description') }
      </Section>
      <Section>
        <SectionImage src={t('community_image')} />
        <SectionTitle>{ t('community_title') }</SectionTitle>
        { t('community_description') }
      </Section>
    </NestedSection>
    <Section light title={t('testimonials_title')}>
      <Grid sizes={{laptop: 4}}>{
        JSON.parse(t('testimonials')).map(who =>
          <Testimonial key={who}
            pic={t(`${who}_pic`)}
            name={t(`${who}_name`)}
            job={t(`${who}_job`)}>
            { t(`${who}_testimonial`) }
          </Testimonial>
        )
      }</Grid>
    </Section>
  </Page>
)
Teachers.displayName = 'Teachers'



// WEBPACK FOOTER //
// ./src/pages/Teachers.js